import { emitScrollEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex) => {
  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: 'loaded'
  };
};
const buildProductTrackingData = (productTracking) => {
  return productTracking.map((it) => {
    return {
      ...it,
      status: 'loaded'
    };
  });
};

export default (widgetTracking, productTracking, featureIndex, scrollDirection) => {
  const event = {
    name: scrollDirection === 'next' ? 'next' : 'previous',
    features: [
      buildWidgetTrackingData(widgetTracking, featureIndex),
      ...buildProductTrackingData(productTracking)
    ]
  };
  emitScrollEvent(event, {});
};
